module.exports = __webpack_public_path__ + "static/media/green_jersey.b98c9132.jpg";